import { evaluateFormCondition } from '@ayumia/component-runtime';

/**
 * Contrôles du panneau de saisie d'une série en registre (ADR-147 §1) : un champ caché par `visible_when`
 * (le motif d'une ligne conforme, la précision d'un motif qui n'est pas « Autre ») n'est pas proposé ; une
 * énumération de plus de {@link LEDGER_TILE_LIMIT} valeurs (le motif de non-conformité, 32 valeurs) se
 * choisit dans une liste, les autres en tuiles. Même règle à la tablette (`ledger_panel.dart`), éprouvée
 * par le jeu partagé `ledger-panel.cases.json`. Présentation seulement : le serveur relit la fiche entière.
 */

export const LEDGER_TILE_LIMIT = 8;

export type PanelControl = 'list' | 'tiles' | 'pad' | 'text';

interface PanelEntry {
  field: { field_id: string; type: string; validation?: { enum_values?: readonly string[] } | undefined };
  presentation?: { widget?: string } | undefined;
  visible_when?: unknown;
}

/** Le contrôle d'un champ de ligne dans le panneau. */
export function panelControl(entry: PanelEntry): PanelControl {
  const { type } = entry.field;
  if (type === 'enumeration') return (entry.field.validation?.enum_values?.length ?? 0) > LEDGER_TILE_LIMIT ? 'list' : 'tiles';
  if (type === 'number' || (type === 'string' && entry.presentation?.widget === 'keypad')) return 'pad';
  return 'text';
}

/** Le champ est-il proposé pour la ligne en cours ? */
export function panelVisible(entry: PanelEntry, draft: Readonly<Record<string, unknown>>): boolean {
  return evaluateFormCondition(entry.visible_when, draft);
}

/** Les champs proposés, dans l'ordre, avec leur contrôle. */
export function panelControls(entries: readonly PanelEntry[], draft: Readonly<Record<string, unknown>>): Array<{ field_id: string; control: PanelControl }> {
  return entries.filter((entry) => panelVisible(entry, draft)).map((entry) => ({ field_id: entry.field.field_id, control: panelControl(entry) }));
}
